<template>
  <div>
    <v-dialog
      :value="true"
      transition="none"
      max-width="800"
      content-class="no-shadow"
      scrollable
      @click:outside="closeDialog"
    >
      <v-img :src="$backendUrl($route.params.url)" alt="image" />
      <v-btn icon class="overlay-close-icon" @click="closeDialog"
        ><v-icon>mdi-close-thick</v-icon></v-btn
      >
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'Images',

  methods: {
    closeDialog() {
      this.$emit('click:close');
    },
  },
};
</script>
